<template>
  <!-- <svg
    viewBox="0 0 180 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="margin: 0.5rem 1rem"
  >
    <path
      d="M174 1H6C3.23858 1 1 3.23858 1 6V41H179V6C179 3.23858 176.761 1 174 1Z"
      fill="#E3F5FC"
    />
    <path
      opacity="0.675"
      d="M107.838 8.49575C106.272 7.57274 104.328 7.57274 102.762 8.49575L75.022 24.8415C73.4556 25.7645 71.5116 25.7645 69.9453 24.8415L59.7219 18.8174C58.1555 17.8944 56.2116 17.8944 54.6452 18.8174L17 41H47.6001H97.3671H163L107.838 8.49575Z"
      fill="#00ADE8"
    />
    <path
      opacity="0.675"
      d="M26 25C30.9706 25 35 20.9706 35 16C35 11.0294 30.9706 7 26 7C21.0294 7 17 11.0294 17 16C17 20.9706 21.0294 25 26 25Z"
      fill="#00ADE8"
    />
    <rect x="1" y="1" width="178" height="118" rx="4" stroke="#00ADE8" stroke-width="2" />
    <rect x="18" y="64" width="143" height="16" rx="1" stroke="#00ADE8" stroke-width="2" />
    <rect x="18" y="51" width="144" height="5" rx="2.5" fill="#E3F5FC" />
    <rect x="17" y="88" width="145" height="18" rx="2" fill="#00ADE8" />
  </svg> -->
  <svg style="margin: 0.5rem 1rem" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_894_49432)">
      <path
        d="M170.527 1C174.657 1 178 2.1178 178 3.50335V41.0134H0.112549V3.50335C0.112549 2.1178 3.45518 1 7.58548 1H170.527Z"
        fill="#CCDCF3"
      />
      <path
        d="M40.8463 32.8942C47.5184 37.4324 53.8793 41.763 60.4255 46.2209C82.1559 32.1646 103.39 18.4297 125.014 4.43372C133.758 10.0897 141.853 15.344 149.988 20.5716C158.467 26.0201 167.065 31.3882 175.412 36.917C176.782 37.8273 177.821 39.3668 177.841 40.6185C178.027 51.9371 177.947 79.5676 177.947 91.0937H0.0133002C0.0133002 86.0201 -0.0462714 64.7483 0.092729 59.7952C0.105967 59.2061 1.05911 58.5368 1.81369 58.0482C14.5422 49.8152 27.3103 41.6091 40.853 32.8942H40.8463Z"
        fill="#0059D5"
      />
      <path
        d="M22.5645 6.44172C28.6275 6.50197 33.6183 11.6224 33.519 17.7001C33.4197 23.7443 28.237 28.838 22.2865 28.7443C16.1572 28.6439 11.312 23.5167 11.3915 17.2115C11.4643 11.2208 16.4815 6.38818 22.5645 6.44172Z"
        fill="#0059D5"
      />
    </g>
    <rect x="1" y="1" width="178" height="118" rx="4" stroke="#0059D5" stroke-width="2" />
    <rect x="18" y="64" width="143" height="16" rx="1" stroke="#0059D5" stroke-width="2" />
    <rect x="18" y="51" width="144" height="5" rx="2.5" fill="#CCDCF3" />
    <rect x="17" y="88" width="145" height="18" rx="2" fill="#0059D5" />
    <defs>
      <clipPath id="clip0_894_49432">
        <rect width="178" height="40" fill="white" transform="translate(0 1)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup></script>
